import React from 'react';
import { Card, CardActionArea, CardContent } from '@prisjakt/ui/card';
import { Clickable } from 'src/components/clickable';
import type { Article } from 'src/types';
import { CardTitle } from 'src/areas/expert/styles';
import { Lazy } from 'src/components/lazy';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { StyledCardMedia } from './styles';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

export const RelatedArticle: React.FC<RelatedArticleProps> = ({
  article,
  preambleMaxLength = 80,
}) => {
  return (
    <Card>
      <CardActionArea
        container={Clickable}
        containerProps={{
          to: article.pathName,
          onClick: () =>
            trackInternalNavigationClick({
              scope: InternalNavigationScope.RELATED_ARTICLE,
              nextPage: article.pathName,
            }),
        }}
      >
        {article.imageUrl && (
          <StyledCardMedia>
            <Lazy loadOnIdle>
              <img alt={article.title} src={article.imageUrl} height={124} />
            </Lazy>
          </StyledCardMedia>
        )}
        <CardContent>
          <CardTitle>{article.title}</CardTitle>

          {article.preamble && (
            <BodySmallText container="p">
              {formatPreamble(article.preamble, preambleMaxLength)}
            </BodySmallText>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

interface RelatedArticleProps {
  article: Article;
  preambleMaxLength?: number;
  orientation?: 'horizontal' | 'vertical';
}

function formatPreamble(str: string, maxLength: number) {
  return str && str.length > maxLength
    ? `${str
        .substr(0, str.substr(0, maxLength).lastIndexOf(' '))
        .trim()}\u00a0…`
    : str;
}
